import { EDocumentType } from "../interfaces";

/**
 * Allowed file extensions for each document type
 */
export const ALLOWED_FILE_EXTENSIONS: Record<EDocumentType, string[]> = {
  [EDocumentType.PROFILE_PIC]: ["jpg", "jpeg", "png"],
  [EDocumentType.AADHAR]: ["jpg", "jpeg", "png", "pdf"],
  [EDocumentType.PAN]: ["jpg", "jpeg", "png", "pdf"],
  [EDocumentType.CANCELLED_CHEQUE]: ["jpg", "jpeg", "png", "pdf"],
  [EDocumentType.SELFIE]: ["jpg", "jpeg", "png"],
  [EDocumentType.LEAVE_PROOF]: ["jpg", "jpeg", "png", "pdf"],
};

export type AllowedFileExtension = (typeof ALLOWED_FILE_EXTENSIONS)[keyof typeof ALLOWED_FILE_EXTENSIONS];

/**
 * File size conversion constants
 */
export const FILE_SIZE_CONSTANTS = {
  BYTES_PER_KB: 1024,
  BYTES_PER_MB: 1024 * 1024,
} as const;